import { buildingTemplatesBySize, TBuilding } from "../../data/buildings";
import { TGamePhase } from "../../data/gameContext";
import { ETownSize, preGenTownNames, TTown, TTownWithDistance } from "../../data/town";
import { GetRandomNumber } from "../../helper/common";
import { calcDistance } from "./mapGenerator";
import { TLocation } from "./mapTypes";

export default function generateTowns(numberOfTowns: number, minDistance: number, edgeGap: number, width: number, height: number): TTown[] {
    var towns: TTown[] =[]

    //The possible ranges are the width and height, minus both edges.
    var xRange = width - (edgeGap * 2);
    var yRange = height - (edgeGap * 2);
    //Make a copy of the names so we can remove them as we use them, so we don't get duplicates.
    var availableTowns = structuredClone(preGenTownNames)

    for(let index = 0; index < numberOfTowns; index++)
    {
        //get one of the remaining names at random
        let town = availableTowns[GetRandomNumber(availableTowns.length)];
       
        //get x and y, reset the check variables
        let isTooClose = false;
        let newLocation:TLocation = {x: 0, y: 0}
        let loopCount = 0; //prevent infite loops
        do {
            isTooClose = false
            //Generate a random location
            newLocation = {
                x: GetRandomNumber(xRange) + edgeGap, 
                y: GetRandomNumber(yRange) + edgeGap
            };
            loopCount++;

            //Check it's not too close, if it is, try again. (if the minDistance is too big this will infi-loop, so be careful!)
            for(let checkIndex = 0; checkIndex < index; checkIndex++){
                if(calcDistance(newLocation, towns[checkIndex].Location) < minDistance) 
                {
                    isTooClose= true;
                    checkIndex = index; //exit the loop
                }
            }
        } while (isTooClose && loopCount < 30); //don't let it carry on indefinitely
        towns = [...towns, {...town, Location: newLocation}];

        availableTowns = availableTowns.filter((x: TTown) => x.Name !== town.Name);
    } 

    //Assign sizes - I think this should be random - 2 big towns, 4 medium, 4 small, but the big towns should have a fair distance between them 
    //- find the the three towns furtherst west, and the three towns furthest west and pick one of the three on each side to be a big city. The others assigned at random, 
    //except Ramsbottom if generated  which is always small (just cos I like the flavour text :-P)
    console.log("Generate towns!!", towns.map(x => x.Location.x))

    //sort them by their x coordinate - this creates a sorted list, but the elements are the same ones in towns, so we can still update it.
    let sortedTowns =  towns.map((town) => (town)).sort((a, b) => a.Location.x - b.Location.x); 
    let west = sortedTowns.slice(0,2).filter((x: TTown) => x.Name !== "Ramsbottom"); //three furthest west, except Ramsbottom
    west[GetRandomNumber(west.length)].Size = ETownSize.Large //pick one to be a city

    let east = sortedTowns.slice(-3,-1).filter((x: TTown) => x.Name !== "Ramsbottom"); //three furthest east, except Ramsbottom
    east[GetRandomNumber(east.length)].Size = ETownSize.Large;  //pick one to be a city

    //just assign the first four generated (other than the large ones) be small. Maybe you can do this with map, not sure
    for(let town of towns.filter(x => x.Size !== ETownSize.Large).slice(0,4))
    {
        town.Size = ETownSize.Small;
    }

    const townsWithBuildings: TTown[] = towns.map(town => ({
        ...town,
        Buildings: generateBuildingsForTown(town, 1920, 600)
    }));
    
    return townsWithBuildings;
    
}

export function nearestTowns(location:TLocation, towns:TTown[]): TTownWithDistance[]
{
  //get the distance to every town and sort them in that order.
  //copy the towns into the extended type with distance
  let newTowns = towns.map((town) => ({...town, distance: calcDistance(location, town.Location)}));

  //sort them by that, closest first 
  newTowns = newTowns.sort((a, b) => a.distance - b.distance)

  //return them
  return newTowns;    
}

function generateBuildingsForTown(town: TTown, canvasWidth: number, canvasHeight: number): TBuilding[] {
    const templates = buildingTemplatesBySize[town.Size];
    const buildingCount = town.Size === ETownSize.Large ? 8 : town.Size === ETownSize.Medium ? 6 : 4;

    const buildings: TBuilding[] = [];
    let attempts = 0;

    while (buildings.length < buildingCount && attempts < 100) {
        const template = templates[Math.floor(Math.random() * templates.length)];
        const left = Math.floor(Math.random() * (canvasWidth - template.Width));
        const top = Math.floor(Math.random() * (canvasHeight - template.Height));

        const overlaps = buildings.some(b =>
            !(left + template.Width < b.Left || b.Left + b.Width < left ||
              top + template.Height < b.Top || b.Top + b.Height < top)
        );

        if (!overlaps) {
            buildings.push({
                Name: template.Name as TGamePhase, 
                Left: left,
                Top: top,
                Width: template.Width,
                Height: template.Height,
                Size: town.Size
            });
        }

        attempts++;
    }

    return buildings;
}

// incase we need to allow scrolling of the town view
function getTownCanvasWidth(buildings: TBuilding[], baseWidth = 1920, padding = 100): number {
    const furthestRight = Math.max(...buildings.map(b => b.Left + b.Width));
    return Math.max(baseWidth, furthestRight + padding);
}
